export default __webpack_public_path__ + "static/media/WJU4.e96ce735.png";